<div class="selection-panel">
  <div class="panel-header">
    <span class="panel-label">DEIN NÄCHSTER SCHRITT</span>
    <h3 class="court-title">{{ hasSelection ? courtName : 'Platz –' }}</h3>
    <span class="panel-meta">
      @if (hasSelection) {
        {{ categoryName }} · {{ formatDate(selectedDate) }}
      } @else {
        {{ categoryName }} · Noch keine Auswahl
      }
    </span>
  </div>

  <!-- One shared block for both states — only the values, the disabled flag
       and the hint text differ; the duration slider is the single piece of
       markup exclusive to the has-selection state. -->
  <div class="time-summary">
    <div class="time-row">
      <span class="time-label">Beginn</span>
      <span class="time-value">{{ hasSelection ? formatTime(startTimeUtc) : '–:–' }}</span>
    </div>
    <div class="time-row">
      <span class="time-label">Ende</span>
      <span class="time-value">{{ hasSelection ? formatTime(endTimeUtc) : '–:–' }}</span>
    </div>
    <div class="time-row">
      <span class="time-label">Dauer</span>
      <span class="time-value">{{ hasSelection ? durationMinutes + ' min' : '– min' }}</span>
    </div>
  </div>

  @if (hasSelection && availableDurations.length > 1) {
    <div class="duration-slider-section">
      <span class="duration-label">DAUER ÄNDERN</span>

      <!-- Custom slider: track + dots + thumb in one container -->
      <div class="custom-slider"
        #sliderTrack
        (mousedown)="onTrackClick($event)"
        (touchstart)="onTrackClick($event)">
        <!-- Track background -->
        <div class="slider-track">
          <div class="slider-track-fill" [style.width.%]="thumbPosition"></div>
        </div>
        <!-- Dots for each option -->
        @for (option of availableDurations; track option.duration; let i = $index) {
          <span class="slider-dot"
            [class.filled]="i <= selectedSliderIndex"
            [class.disabled]="!option.available"
            [style.left.%]="dotPosition(i)">
          </span>
        }
        <!-- Thumb -->
        <div class="slider-thumb"
          [style.left.%]="thumbPosition"
          (mousedown)="onThumbDragStart($event)"
          (touchstart)="onThumbDragStart($event)">
        </div>
      </div>

      <!-- Tick labels -->
      <div class="slider-ticks">
        @for (option of availableDurations; track option.duration; let i = $index) {
          <span class="tick-label"
            [class.active]="i === selectedSliderIndex"
            [class.disabled]="!option.available"
            [style.left.%]="dotPosition(i)"
            (click)="onTickClick(i)">
            {{ option.duration }}m
          </span>
        }
      </div>
    </div>
  }

  <div class="price-section">
    <span class="price-label">Gesamt</span>
    <span class="price-value">{{ hasSelection ? ((price | number:'1.2-2') + ' €') : '–,–– €' }}</span>
  </div>

  <button
    class="btn btn-full btn-warning btn-icon-right reserve-btn"
    [disabled]="!hasSelection"
    (click)="onReserveClick()">
    <span class="btn-text">Weiter zu Mitspielern</span>
    <span class="btn-icon">→</span>
  </button>

  <p class="step-info">{{ hasSelection ? 'Schritt 1 / 3 · Mitspieler & Zahlung folgen' : 'Wähle im Raster eine freie Stunde, um fortzufahren' }}</p>
</div>
